"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _auth = require("../constants/auth.constants");

var _auth2 = require("./auth.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  authenticated: false,
  authorized: false,
  hasErrors: false,
  loading: false,
  accessTokenIsRequesting: false,
  userInfo: {
    email: '',
    firstName: '',
    lastName: '',
    userName: '',
    image: '',
    roles: [],
    permissions: [],
    adminId: null
  }
};
exports.initialState = initialState;

var _default = (0, _reduxAct.createReducer)({}, initialState).on(_auth2.authComplete, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    authenticated: true,
    authorized: true
  });
}).on(_auth2.authFailed, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    hasErrors: true,
    error: _auth.AUTH_ERROR_DESCRIPTIONS[payload.message]
  });
}).on(_auth2.logoutRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}).on(_auth2.logoutSuccess, function () {
  return _objectSpread(_objectSpread({}, initialState), {}, {
    loading: true
  });
}).on(_auth2.refreshTokenRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    accessTokenIsRequesting: true
  });
}).on(_auth2.refreshTokenSuccess, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    accessTokenIsRequesting: false,
    authenticated: true
  });
}).on(_auth2.refreshTokenFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    accessTokenIsRequesting: false
  });
}).on(_auth2.updateUserInfoFields, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    userInfo: _objectSpread(_objectSpread(_objectSpread({}, state.userInfo), payload), {}, {
      userName: "".concat(payload.firstName, " ").concat(payload.lastName ? "".concat(payload.lastName[0], ".") : '')
    })
  });
});

exports.default = _default;